import React, { useEffect, useRef, useState } from "react";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";

import "./PrivacyPolicy.scss";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer2";
import LineWhiteArrowIcon from "../../assets/images/LineWhiteArrow.svg";

function PrivacyPolicy() {
  const navigate = useNavigate();
  const sections = [
    "introduction",
    "ourvalues",
    "process-info",
    "rightsover-info",
    "send-info",
  ];
  const [activeSection, setActiveSection] = useState("introduction");
  const sectionRefs = useRef({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.6 }
    );

    sections.forEach((id) => {
      observer.observe(sectionRefs.current[id]);
    });

    return () => observer.disconnect();
  }, []);

  const handleMenuClick = (id) => {
    sectionRefs.current[id].scrollIntoView({ behavior: "smooth" });
    setActiveSection(id);
  };

  const breadcrumbsMobile = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#A9A9A9",
      }}
    >
      Home
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#ffffff",
      }}
    >
      Privacy Policy
    </Typography>,
  ];

  return (
    <>
      <Header />
      <div className="privacyhome">
        <div className="home-bg">
          <div
            className="container mobile_content left-mb"
            style={{
              position: "absolute",
              top: "20px",
              left: "16px",
              width: "90%",
            }}
          >
            <Breadcrumbs
              separator={
                <NavigateNextIcon fontSize="small" sx={{ color: "#A9A9A9" }} />
              }
              aria-label="breadcrumb"
            >
              {breadcrumbsMobile}
            </Breadcrumbs>
          </div>
          <div className="heading">
            <div className="back" onClick={() => navigate(-1)}>
              <img src={LineWhiteArrowIcon} alt="back arrow" />
            </div>
            <p className="redtext">Updated 25 July, 2025</p>
            <h1 className="privacytext">Privacy Policy</h1>
            <p className="headbottom">How DLF Malls handle your data</p>
          </div>
        </div>
        <div className="privacy-bg">
          <div className="privacy-div">
            <div className="table-content">
              <p className="content-head">Table of Contents</p>
              <div>
                <p
                  className={`content-subhead ${
                    activeSection === "introduction" ? "active" : ""
                  }`}
                  onClick={() => handleMenuClick("introduction")}
                >
                  Introduction
                </p>
                <p
                  className={`content-subhead ${
                    activeSection === "ourvalues" ? "active" : ""
                  }`}
                  onClick={() => handleMenuClick("ourvalues")}
                >
                  What this Privacy Policy Covers
                </p>
                <p
                  className={`content-subhead ${
                    activeSection === "process-info" ? "active" : ""
                  }`}
                  onClick={() => handleMenuClick("process-info")}
                >
                  Information Collection and Use
                </p>
                <p
                  className={`content-subhead ${
                    activeSection === "rightsover-info" ? "active" : ""
                  }`}
                  onClick={() => handleMenuClick("rightsover-info")}
                >
                  The following information is collected
                </p>
                <p
                  className={`content-subhead ${
                    activeSection === "send-info" ? "active" : ""
                  }`}
                  onClick={() => handleMenuClick("send-info")}
                >
                  Information Sharing and Disclosure
                </p>
                {/* <p className={`content-subhead ${activeSection === 'retain-info' ? 'active' : ''}`} onClick={() => handleMenuClick('retain-info')}>How long do we retain your information</p>
                    <p className={`content-subhead ${activeSection === 'machine-learning' ? 'active' : ''}`} onClick={() => handleMenuClick('machine-learning')}>Our use of Machine Learning</p>
                    <p className={`content-subhead ${activeSection === 'protect-info' ? 'active' : ''}`} onClick={() => handleMenuClick('protect-info')}>How we protect your information</p>
                    */}
              </div>
            </div>
            <div className="privacy-content">
              <div
                className="introduction"
                id="introduction"
                ref={(el) => (sectionRefs.current["introduction"] = el)}
              >
                <p className="tablehead">Introduction</p>
                <p className="content-div">
                  DLF Limited is committed to maintain the privacy and accuracy
                  of the information that has been provided on this site. All
                  information is provided with the complete knowledge of owner
                  and appropriate measures have been taken to ensure that user's
                  credentials are not misused, accidentally destroyed or lost
                  within the environment of DLF Limited. Through care has been
                  taken in the production of information on this website, DLF
                  Limited will not be responsible and accept any liability for
                  loss incurred in anyway whatsoever, by anyone who may seek to
                  depend on the information contained herein.
                </p>
              </div>
              <div
                className="ourvalues"
                id="ourvalues"
                ref={(el) => (sectionRefs.current["ourvalues"] = el)}
              >
                <p className="tablehead">What this Privacy Policy Covers</p>
                <div className="content-div">
                  <ul>
                    <li>
                      This Privacy Policy covers our usage of personally
                      identifiable material that is shared by you on our site.
                      This Policy also covers treatment of any personally
                      identifiable information shared with us.
                    </li>
                    <li>
                      The Privacy Policy Covers personally identifiable material
                      that may be collected through the use of any app owned and
                      operated by DLF Limited.
                    </li>
                    <li>
                      This Privacy Policy does not apply to the activities of
                      organizations not owned or controlled by us, or to people
                      who are not employed or managed by us as also in respect
                      of information required to be shared with public/private
                      authority by operation of any applicable law, court order
                      or direction.
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="process-info"
                id="process-info"
                ref={(el) => (sectionRefs.current["process-info"] = el)}
              >
                <p className="tablehead">Information Collection and Use</p>
                <div className="content-div">
                  <ul>
                    <li>
                      We use your personal information only for providing and
                      improving the site. By using the site, you agree to the
                      collection and use of information in accordance with this
                      Privacy Policy.
                    </li>
                    <li>
                      We compile personally identifiable information when you
                      submit the enquiry form on our website or through
                      interactions with our apps.
                    </li>
                    <li>
                      While using our website, we may ask you to provide us with
                      certain personally identifiable information that can be
                      used to contact or identify you and you consent to be
                      contacted. Personally identifiable information may include
                      but is not limited to your name. This consent will
                      override the DNC/NDNC.
                    </li>
                    <li>
                      When you submit a form, we ask for your name, email
                      address and phone number apart from what you mention in
                      your comments. Once the form is submitted and it reaches
                      us, the information provided by you is saved in our
                      database and is not shared with any third party.
                    </li>
                    <li>
                      We use this information to revert to your query and future
                      reference, and to contact you about products & services.
                    </li>
                    <li>
                      Like many site operators, we collect information that your
                      browser sends whenever you visit our site. This log data
                      may include information such as your computer's internet
                      protocol, IP address, browser type, browser version, the
                      pages of our site that you visit, the time and date of
                      your visit, the time spent on those pages and other
                      statistics.
                    </li>
                    <li>
                      Technical details such as device information, location and
                      network carrier when you use our mobile app.
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="rightsover-info"
                id="rightsover-info"
                ref={(el) => (sectionRefs.current["rightsover-info"] = el)}
              >
                <p className="tablehead">
                  The following information is collected
                </p>
                <div className="content-div">
                  <ul>
                    <li>
                      Information about you - Your personal information such as
                      your name, gender, age, images, contact/ postal address,
                      telephone, email id, nationality and content.
                    </li>
                    <li>
                      Our interactions with you - A record of any interactions
                      and correspondence between us such as any interactions you
                      have with our team members and any interactions with us
                      online or posts that refer to us on social media;
                    </li>
                    <li>
                      Survey information - Your responses to customer surveys
                      conducted by us or on our behalf.
                    </li>
                    <li>
                      Your use of our website, apps and social media platforms -
                      Details of your visits to our website, your use of social
                      media platforms and our mobile applications and other
                      information collected through cookies and other tracking
                      technology including information that you look at.
                    </li>
                    <li>
                      Online Identifiers - such as your mobile device
                      advertising identifier and geo-location data when using
                      any DLF mobile application.
                    </li>
                    <li>
                      Geo-location data is used during registration process with
                      DLF apps to assist with delivering location specific
                      services.
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="send-info"
                id="send-info"
                ref={(el) => (sectionRefs.current["send-info"] = el)}
              >
                <p className="tablehead">Information Sharing and Disclosure</p>
                <div className="content-div">
                  <ul>
                    <li>
                      We do not sell, rent or share personally identifiable
                      information made available to us.
                    </li>
                    <li>
                      We share personally identifiable information to other
                      companies or people only if
                      <ol className="numbered">
                        <li>
                          We have consent to share the information; or we may
                          disclose personal information if required to do so by
                          law or in the good faith belief that such disclosure
                          is reasonably necessary to respond to court
                          orders/summons/directions, or other legal process. We
                          may disclose personal information to law enforcement
                          offices, third party rights owners, or others in the
                          good faith belief that such disclosure is reasonably
                          necessary to: enforce our Terms of Privacy Policy;
                          respond to claims that an advertisement, posting or
                          other content violates the rights of a third party; or
                          protect the rights, property or personal safety of our
                          users or the general public.
                        </li>
                        <li>
                          We find that your actions on our websites violate the
                          Terms of Service
                        </li>
                      </ol>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="content-div">
                The content and design of the website are the exclusive property
                of DLF Limited. No person can use or reproduce or allow any
                other to use or reproduce any image or logo (such as the name)
                for any reason without prior written consent from DLF Limited.
                No person is allowed to retrieve and display the content
                available on this website for personal, commercial and
                non-commercial purpose, or cannot reproduce, modify or in any
                way to make commercial use of the content. The use of content on
                this website without permission is prohibited. The Privacy
                Policy is subject to change and any modification to the Privacy
                Policy will be communicated here.
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer selected="home" />
    </>
  );
}

export default PrivacyPolicy;
